module.exports = __webpack_public_path__ + "img/free.b358572b.svg";